export default function About() {
  return (
    <section id="about" className="bg-background-100 section-padding">
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              关于平台
            </h2>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                <strong className="text-foreground-900">青青草视频</strong>是一家专注于影视平台聚合与推荐的在线导航服务，
                致力于帮助用户在海量影视平台中快速找到最适合自己的观影入口。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                我们深知，面对众多影视平台——香蕉视频的丰富资源、红桃视频的原创精品、91视频的活跃社区、
                蜜桃视频的流畅体验、樱花视频的快速崛起、糖豆视频的特色内容、樱桃视频的精致品质——
                用户往往难以全面了解和比较。青青草视频正是为解决这一问题而诞生。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                我们以客观中立的视角，从内容资源、更新频率、播放技术、用户体验、社区口碑等多个维度，
                对各大影视平台进行整理和展示，帮助用户做出明智的选择。青青草视频本身不存储任何视频文件，
                不提供视频播放服务，仅作为信息聚合与导航平台。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                自上线以来，青青草视频已累计服务数百万影视爱好者，聚合超过15家优质影视平台，
                每日更新内容动态与行业资讯，持续为用户提供高质量的平台发现与参考服务。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们的愿景：成为中文互联网上最值得信赖的影视平台聚合入口，
                让每一位用户都能轻松找到适合自己的高清免费在线观影体验。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/70">
              <div className="text-center">
                <div className="text-xl font-heading font-bold text-primary-600">15+</div>
                <div className="text-xs text-foreground-500 mt-1">聚合平台</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-heading font-bold text-accent-600">200万+</div>
                <div className="text-xs text-foreground-500 mt-1">服务用户</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-heading font-bold text-primary-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">内容动态</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-heading font-bold text-accent-600">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">无任何收费</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}